import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { Feature } from './Feature'
import { FeaturesProps } from './types'

const Features: FC<FeaturesProps> = ({
  className,
  children,
  features = [],
  ...props
}) => {
  const { t } = useTranslation()
  return (
    <div
      className={classNames(
        'grid grid-cols-[repeat(auto-fit,minmax(min-content,96px))] gap-2 justify-between',
        className
      )}
      {...props}
    >
      {features.map(({ title, icon, content }, idx) => (
        <Feature
          key={idx}
          icon={
            icon && {
              src: icon.src,
              alt: icon?.alt,
            }
          }
        >
          <Feature.Title>{title}</Feature.Title>
        </Feature>
      ))}
    </div>
  )
}

export { Features }
